
import React, { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import $ from "jquery";
import '../css/responsive.css'

// let configFields = {
//     businessPartner:{
//         // DATOS MAESTROS
//         BPMD0: { id: "BPMD0", show: true, edit: true },
//         BPMD1: { id: "BPMD1", show: true, edit: true },
//         BPMD2: { id: "BPMD2", show: true, edit: true },
//         BPMD3: { id: "BPMD3", show: true, edit: true },
//         BPMD4: { id: "BPMD4", show: true, edit: true },
//         BPMD5: { id: "BPMD5", show: true, edit: true },
//         // GENERAL
//         BPG0: { id: "BPG0", show: true, edit: true },
//         BPG1: { id: "BPG1", show: true, edit: true },
//         BPG2: { id: "BPG2", show: true, edit: true },
//         BPG3: { id: "BPG3", show: true, edit: true },
//         BPG4: { id: "BPG4", show: true, edit: true },
//         // CONDICION DE PAGO
//         BPC0: { id: "BPC0", show: true, edit: true },
//         BPC1: { id: "BPC1", show: true, edit: true },
//         BPC2: { id: "BPC2", show: true, edit: true },
//         BPC3: { id: "BPC3", show: true, edit: true },
//         BPC4: { id: "BPC4", show: true, edit: true },
//         BPC5: { id: "BPC5", show: true, edit: true },
//         BPC6: { id: "BPC6", show: true, edit: true },
//         BPC7: { id: "BPC7", show: true, edit: true },
//         BPC8: { id: "BPC8", show: true, edit: true },
//         BPC9: { id: "BPC9", show: true, edit: true },
//         BPC10: { id: "BPC10", show: true, edit: true },
//         BPC11: { id: "BPC11", show: true, edit: true },
//         // DIRECCION DE FACTURACION
//         BPIA0: { id: "BPIA0", show: true, edit: true },
//         BPIA1: { id: "BPIA1", show: true, edit: true },
//         BPIA2: { id: "BPIA2", show: true, edit: true },
//         BPIA3: { id: "BPIA3", show: true, edit: true },
//         BPIA4: { id: "BPIA4", show: true, edit: true },
//         BPIA5: { id: "BPIA5", show: true, edit: true },
//         BPIA6: { id: "BPIA6", show: true, edit: true },
//         BPIA7: { id: "BPIA7", show: true, edit: true },
//         BPIA8: { id: "BPIA8", show: true, edit: true },
//         BPIA9: { id: "BPIA9", show: true, edit: true },
//         BPIA10: { id: "BPIA10", show: true, edit: true },
//         BPIA11: { id: "BPIA11", show: true, edit: true },
//         BPIA12: { id: "BPIA12", show: true, edit: true },
//         // BPIA13:{id:"BPIA13",show:true,edit:true},  
//         // DIRECCION DE ENTREGA
//         BPDA0: { id: "BPDA0", show: true, edit: true },
//         BPDA1: { id: "BPDA1", show: true, edit: true },
//         BPDA2: { id: "BPDA2", show: true, edit: true },
//         BPDA3: { id: "BPDA3", show: true, edit: true },
//         BPDA4: { id: "BPDA4", show: true, edit: true },
//         BPDA5: { id: "BPDA5", show: true, edit: true },
//         BPDA6: { id: "BPDA6", show: true, edit: true },
//         BPDA7: { id: "BPDA7", show: true, edit: true },
//         BPDA8: { id: "BPDA8", show: true, edit: true },
//         BPDA9: { id: "BPDA9", show: true, edit: true },
//         BPDA10: { id: "BPDA10", show: true, edit: true },
//         BPDA11: { id: "BPDA11", show: true, edit: true },
//         BPDA12: { id: "BPDA12", show: true, edit: true },
//         BPDA13: { id: "BPDA13", show: true, edit: true },
//         BPDA14: { id: "BPDA14", show: true, edit: true },
//         // PERSONA CONTACTO
//         BPCP0: { id: "BPCP0", show: true, edit: true },
//         BPCP1: { id: "BPCP1", show: true, edit: true },
//         BPCP2: { id: "BPCP2", show: true, edit: true },
//         BPCP3: { id: "BPCP3", show: true, edit: true },
//         BPCP4: { id: "BPCP4", show: true, edit: true },
//         BPCP5: { id: "BPCP5", show: true, edit: true },
//         BPCP6: { id: "BPCP6", show: true, edit: true },
//         BPCP7: { id: "BPCP7", show: true, edit: true },
//         BPCP8: { id: "BPCP8", show: true, edit: true },
//         BPCP9: { id: "BPCP9", show: true, edit: true },
//         BPCP10: { id: "BPCP10", show: true, edit: true },
//         BPCP11: { id: "BPCP11", show: true, edit: true },
//         BPCP12: { id: "BPCP12", show: true, edit: true },
//         BPCP13: { id: "BPCP13", show: true, edit: true },
//         BPCP14: { id: "BPCP14", show: true, edit: true },
//         BPCP15: { id: "BPCP15", show: true, edit: true },
//         // FINANZAS
//         BPF0: { id: "BPF0", show: true, edit: true },
//         BPF1: { id: "BPF1", show: true, edit: true },
//         BPF2: { id: "BPF2", show: true, edit: true },
//         BPF3: { id: "BPF3", show: true, edit: true },
//         BPF4: { id: "BPF4", show: true, edit: true },
//         BPF5: { id: "BPF5", show: true, edit: true },
//         BPF6: { id: "BPF6", show: true, edit: true },
//     },
//     itemData:{}
// }



let BusinessPartnerFields = (props) => {
    const { adminUsersModel, refreshModel, configFields, editMode, action, showAlert, userConfig } = props;
    const { register, handleSubmit } = useForm({
        defaultValues: userConfig
        // defaultValues: (defaultConfig)
    });

    const onSubmit = (data) => {
        for (const key in configFields.businessPartner) {
            if (Object.hasOwnProperty.call(configFields.businessPartner, key)) {
                const busisness = configFields.businessPartner[key];
                for (const key2 in data) {
                    if (Object.hasOwnProperty.call(data, key2)) {
                        const value = data[key2];
                        if (`show_${key}` === key2) {
                            busisness.show = value
                        } else if (`edit_${key}` === key2) {
                            busisness.edit = value
                        }
                    }
                }
            }
        }
        setConfigModules(configFields)
        localStorage.setItem('userConfigFielsBP', JSON.stringify(configFields.businessPartner));//este es el bueno
        // localStorage.setItem('userConfigFiels', JSON.stringify(data));
        showAlert({ type: 'info', message: 'Se guardo la configuración de campos del socio de negocios' });
    }

    function setConfigModules(businessPartner) {
        adminUsersModel.U_FMB_ConfigModules = businessPartner;
        refreshModel(adminUsersModel);
    }

    function DisableChecks(field) {

        let element = document.getElementById(field);

        if (element !== null) {
            if (editMode === false) {
                $("#" + field).find("input").attr("disabled", "disabled");
                $("#" + field).find("a").addClass("disablehyper").click(function (e) { e.preventDefault(); });
                $("#" + field).find("input").addClass("disable");
            } else {
                $("#" + field).find("input").removeAttr("disabled");
                $("#" + field).find("a").removeClass("disablehyper").unbind("click");
                $("#" + field).find("input").removeClass("disable");
            }
        }
    }


    return (
        <Fragment>
            {action === 2 ? DisableChecks("checksBP") : ""}
            {editMode === true || action === 1 ?
                <div className='text-right'>
                    <button className='btn mt-4 sucursal' onClick={handleSubmit(onSubmit)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>GUARDAR CAMPOS S. DE NEGOCIOS</button>
                </div>
                : ""
            }
            {/* CAMPOS DE USUARIO */}
            {/* <div className='row mt-5'>
                <div className='col-6'>
                    <h5 className='mb-4'>Campos de Usuario</h5>
                    <form >
                        <table>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th className='text-center'>Mostrar</th>
                                    <th className='text-center'>Editar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Main Usage</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPUF0")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPUF0")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>eCommerce Email</td>
                                    <td className='text-center' >
                                        <input type="checkbox" {...register("show_BPUF1")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPUF1")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>eCommerce Contraseña</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPUF2")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPUF2")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Tipo de cliente</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPUF3")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPUF3")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Id Sucursal</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPUF4")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPUF4")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Catalogo uso CFDI</td>
                                    <td className='text-center' >
                                        <input type="checkbox" {...register("show_BPUF5")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPUF5")} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div> */}
            <div className='row mt-5' id="checksBP">
                <div className="col-12 col-md-6">
                    <h5 className='mb-4'>Campos SAP</h5>
                    <form>
                    <div className="table-responsive">
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th className='text-center'>Mostrar</th>
                                    <th className='text-center'>Editar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* DATOS MAESTROS */}
                                {/* <tr>
                                    <td>Código</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDM0")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDM0")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Tipo</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPMD1")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPMD1")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Nombre</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPMD2")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPMD2")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Grupo</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPMD3")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPMD3")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Moneda</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPMD4")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPMD4")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>RFC</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPMD5")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPMD5")} />
                                    </td>
                                </tr> */}
                                <tr>
                                    <td className='text-center' colSpan={3} style={{ background: "#eabf28" }}><strong>General</strong></td>
                                </tr>
                                <tr>
                                    <td>Teléfono 1</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPG0")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPG0")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Teléfono 2</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPG1")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPG1")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Correo</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPG2")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPG2")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Activo/Inactivo</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPG3")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPG3")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Empleado ventas</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPG4")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPG4")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-center' colSpan={3} style={{ background: "#eabf28" }}><strong>Condición de pago</strong></td>
                                </tr>
                                <tr>
                                    <td>Cond. de Pago</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC0")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC0")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Lista de Precios</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC1")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC1")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>País del banco</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC2")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC2")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Nombre del banco</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC3")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC3")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Código bancario</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC4")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC4")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Cuenta</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC5")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC5")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Código BIC/SWIFT</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC6")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC6")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Sucursal</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC7")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC7")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>ID int.ctrl.</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC8")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC8")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>IBAN</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC9")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC9")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Límite crédito</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC10")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC10")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Límite compra</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPC11")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPC11")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-center' colSpan={3} style={{ background: "#eabf28" }}><strong>Dirección de facturación</strong></td>
                                </tr>
                                <tr>
                                    <td>Facturación estándar</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA0")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA0")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>ID dirección</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA1")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA1")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Calle/número</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA2")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA2")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Colonia</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA3")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA3")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Ciudad</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA4")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA4")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Código Postal</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA5")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA5")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Condado</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA6")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA6")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>País</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA7")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA7")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Estado</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA8")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA8")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>No. Calle</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA9")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA9")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Edificio/planta</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA10")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA10")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>GLN</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA11")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA11")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fijar como estándar</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPIA12")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPIA12")} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </form>
                </div>
                <div className="col-12 col-md-6">
                    <form>
                    <div className="table-responsive">
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th className='text-center'>Mostrar</th>
                                    <th className='text-center'>Editar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='text-center' colSpan={3} style={{ background: "#eabf28" }}><strong>Dirección de Entrega</strong></td>
                                </tr>
                                <tr>
                                    <td>Dirección de factura</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA0")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA0")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Facturación estándar</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA1")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA1")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>ID dirección</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA2")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA2")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Calle/número</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA3")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA3")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Colonia</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA4")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA4")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Ciudad</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA5")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA5")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Código Postal</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA6")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA6")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Condado</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA7")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA7")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>País</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA8")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA8")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Estado</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA9")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA9")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>No. Calle</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA10")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA10")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Edificio/planta/Sale</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA11")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA11")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>GLN</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA12")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA12")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fijar como estándar</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPDA13")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPDA13")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-center' colSpan={3} style={{ background: "#eabf28" }}><strong>Persona de contacto</strong></td>
                                </tr>
                                <tr>
                                    <td>Contacto</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP0")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP0")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Contacto Default</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP1")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP1")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Nombre</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP2")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP2")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Título</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP3")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP3")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Segundo Nombre</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP4")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP4")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Posición</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP5")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP5")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Apellido</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP6")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP6")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Teléfono 1</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP7")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP7")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Teléfono 2</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP8")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP8")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Celular</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP9")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP9")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fax</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP10")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP10")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP11")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP11")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Observaciones 1</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP12")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP12")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Observaciones 2</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP13")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP13")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Activo</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP14")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP14")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fijar como estándar</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPCP15")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPCP15")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-center' colSpan={3} style={{ background: "#eabf28" }}><strong>Finanzas</strong></td>
                                </tr>
                                <tr>
                                    <td>Consolidación de pagos</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPF0")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPF0")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Consolidación de entregas</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPF1")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPF1")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Proveedores</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPF2")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPF2")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Obligatorio</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPF3")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPF3")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Extranjeros</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPF4")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPF4")} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Indicador de impuestos</td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("show_BPF5")} />
                                    </td>
                                    <td className='text-center'>
                                        <input type="checkbox" {...register("edit_BPF5")} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )

}

export default BusinessPartnerFields;